import useFirebaseData from "./useFirebaseData";
import type { FirebaseRecord, UserRecord } from "../types";

const useFirebaseUsers = () => {
  return useFirebaseData<FirebaseRecord<UserRecord>>("/users");
};

export default useFirebaseUsers;
